var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.feature),function(featu){return _c('li',{key:featu},[_vm._v(" "+_vm._s(featu.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }